export default "__VITE_ASSET__BPm7bjRE__"